// extracted by mini-css-extract-plugin
export default {"pill":"TestAgencyPill_pill__NrE3Y"};